import { render, staticRenderFns } from "./EditSuggestion.vue?vue&type=template&id=15297ff4"
import script from "./EditSuggestion.vue?vue&type=script&lang=js"
export * from "./EditSuggestion.vue?vue&type=script&lang=js"
import style0 from "./EditSuggestion.vue?vue&type=style&index=0&id=15297ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports